import React from "react";
import Dashboard from "./components/Dashboard/Dashboard";
import Students from "./components/Students/Students";
import Student from "./components/Students/Student";
import DashboardIcon from "@material-ui/icons/Dashboard";
import PeopleIcon from "@material-ui/icons/People";
import Expenses from "./components/Expenses/Expenses";
import Payments from "./components/Payments/Payments";
import MoneyOffIcon from "@material-ui/icons/MoneyOff";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import CardPayment from "./components/Payments/CardPayment";
import SchoolIcon from "@material-ui/icons/School";
import Classroom from "./components/Educations/Classroom";
import Parents from "./components/Parents/Parents";
import Parent from "./components/Parents/Parent";
import Education from "./components/Educations/Education";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SettingsIcon from "@material-ui/icons/Settings";
import { faUserGraduate } from "@fortawesome/free-solid-svg-icons";
import Settings from "./components/Settings/Settings";
import familyIcon from "./assets/images/icons/family-white.png";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import Statistics from "./components/Statistics/Statistics";
import StoreIcon from "@material-ui/icons/Store";
import Furnishers from "./components/Furnishers/Furnishers";
import Furnisher from "./components/Furnishers/Furnisher";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import Teachers from "./components/Teachers/Teachers";
import Teacher from "./components/Teachers/Teacher";
import Classrooms from "./components/Classrooms/Classrooms";
import ClassroomManagement from "./components/Classrooms/Classroom";
import Exam from "./components/Exams/Exam";

interface RoutingReference {
  path: string;
  name: string;
  icon: any;
  hideInMenu?: boolean;
  component?: any;
  children?: RoutingChild[];
}

interface RoutingChild {
  path: string;
  hideInMenu?: boolean;
  name: string;
  initials: string;
  component: any;
}

const appRoutes: RoutingReference[] = [
  {
    name: "routes.dashboard",
    path: "/dashboard",
    icon: <DashboardIcon />,
    component: <Dashboard />,
  },
  // {
  //   name: "routes.educations",
  //   path: "/educations",
  //   icon: <SchoolIcon />,
  //   component: <Educations />,
  // },
  {
    name: "routes.education",
    path: "/education/:educationId",
    icon: <SchoolIcon />,
    component: <Education />,
    hideInMenu: true,
  },
  {
    name: "routes.classroom",
    path: "/classroom/:classroomId",
    icon: <SchoolIcon />,
    component: <Classroom />,
    hideInMenu: true,
  },
  {
    name: "routes.students",
    path: "/students",
    icon: <FontAwesomeIcon icon={faUserGraduate} size="lg" />,
    component: <Students />,
  },
  {
    name: "routes.parents",
    path: "/parents",
    icon: (
      <img
        src={familyIcon}
        style={{ height: "24px", color: "white" }}
        alt="family icon"
      />
    ),
    component: <Parents />,
  },
  {
    name: "routes.parent",
    path: "/parent/:parentId",
    icon: (
      <img
        src={familyIcon}
        style={{ height: "24px", color: "white" }}
        alt="family icon"
      />
    ),
    component: <Parent />,
    hideInMenu: true,
  },
  {
    name: "routes.student",
    path: "/student/:studentId",
    icon: <PeopleIcon />,
    component: <Student />,
    hideInMenu: true,
  },
  {
    name: "routes.payments",
    path: "/payments",
    icon: <AttachMoneyIcon />,
    component: <Payments />,
  },
  {
    name: "routes.payment",
    path: "/payment/:paymentId",
    component: <CardPayment />,
    icon: <AttachMoneyIcon />,
    hideInMenu: true,
  },
  {
    name: "routes.expenses",
    path: "/expenses",
    icon: <MoneyOffIcon />,
    component: <Expenses />,
  },
  {
    name: "routes.furnishers",
    path: "/furnishers",
    icon: <StoreIcon />,
    component: <Furnishers />,
  },
  {
    name: "routes.furnisher",
    path: "/furnisher/GetById/:furnisherId",
    icon: <StoreIcon />,
    component: <Furnisher />,
    hideInMenu: true,
  },
  {
    name: "routes.teachers",
    path: "/teachers",
    icon: <PersonOutlineIcon />,
    component: <Teachers />,
  },
  {
    name: "routes.teacher",
    path: "/teacher/:teacherId",
    icon: <PersonOutlineIcon />,
    component: <Teacher />,
    hideInMenu: true,
  },
  {
    name: "routes.classrooms",
    path: "/classrooms",
    icon: <SchoolIcon />,
    component: <Classrooms />,
  },
  {
    name: "routes.classroomManagement",
    path: "/classroom-management/:classroomId",
    icon: <SchoolIcon />,
    component: <ClassroomManagement />,
    hideInMenu: true,
  },
  {
    name: "routes.exam",
    path: "/exam/:examId",
    icon: <SchoolIcon />,
    component: <Exam />,
    hideInMenu: true,
  },
  {
    name: "routes.statistics",
    path: "/statistics",
    icon: <EqualizerIcon />,
    component: <Statistics />,
  },
  {
    name: "routes.settings",
    path: "/settings",
    icon: <SettingsIcon />,
    component: <Settings />,
  },
];

export default appRoutes;
